import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import selectWhyBuyMedia, {
  type SelectedWhyBuyMedia
} from '~/utilities/vdp/selectWhyBuyMedia';
import sortWhyBuyNarratives, {
  WHY_BUY_SORT_PARAM
} from '~/utilities/vdp/sortWhyBuyNarratives';
import useWhyBuyData from './useWhyBuyData';

export type WhyBuyNarrativeItem = {
  bulletType?: string;
  content: string;
  id: string;
  media?: SelectedWhyBuyMedia;
  title: string;
};

export default function useWhyBuyNarratives(): Array<WhyBuyNarrativeItem> {
  const { bulletPoints } = useWhyBuyData();
  const sort = useSearchParams()?.get(WHY_BUY_SORT_PARAM) ?? null;

  return useMemo(() => {
    const displayed = (bulletPoints ?? []).flatMap(
      ({ bulletType, content, media, title }) =>
        content && title ? [{ bulletType, content, media, title }] : []
    );
    const selectedMedia = selectWhyBuyMedia(displayed);
    const sorted = sortWhyBuyNarratives(
      displayed.map(({ bulletType, content, title }, index) => ({
        bulletType,
        content,
        media: selectedMedia[index],
        title
      })),
      sort
    );

    return sorted.map((narrative, index) => ({
      ...narrative,
      id: `why-buy-narrative-${index}`
    }));
  }, [bulletPoints, sort]);
}
